import styled from 'styled-components';

export const LocalSearchResult = styled.div`
  position: absolute;
  background-color: ${({ theme }) =>
    theme.colours.canvas.tertiary.main} !important;
  box-shadow: ${({ theme }) =>
    theme.isDark ? 'none' : theme.effects.dropShadow.regular};
  overflow-y: scroll;
  max-height: 300px;
  border: 0 !important;

  .result {
    line-height: 2;
    padding: 0 !important;
    border: 0 !important;
    display: flex !important;

    &:hover,
    &.active {
      background: ${({ theme }) =>
        theme.colours.canvas.secondary.strong} !important;
      color: ${({ theme }) => theme.colours.ink.primary.main} !important;
    }

    a,
    button {
      background: none;
      justify-content: flex-start;
      padding: ${({ theme }) => theme.sizing.tiny}
        ${({ theme }) => theme.sizing.large};
      color: ${({ theme }) => theme.colours.ink.primary.main} !important;
      text-decoration: none;
      text-align: left;
      border-radius: 0 !important;

      &:hover {
        color: ${({ theme }) => theme.colours.ink.primary.main} !important;
      }
    }

    .warningIcon {
      position: relative;
      left: 13px;
    }
  }
`;
LocalSearchResult.displayName = 'LocalSearchResult';
